<template>
    <transition appear name="fade-transition">
        <v-container fluid :class="classList">
            <v-row class="app-row__row align-top" no-gutters>
                <v-col :cols="leftCol" class="app-row__left">
                    <p v-if="label" class="text--secondary mb-0 px-2 py-3" style="font-size: 0.9rem">
                        {{ label }}
                    </p>
                    <slot v-else name="left" />
                </v-col>
                <v-col :cols="rightCol" class="app-row__right d-flex flex-column justify-center">
                    <slot v-if="findSlot('right')" name="right" />
                    <slot v-else />
                </v-col>
            </v-row>
        </v-container>
    </transition>
</template>

<script>
export default {
    name: 'AppRow',
    props: {
        label: {
            type: String,
            default: null
        },
        leftCol: {
            type: [Number, String],
            default: 3
        },
        rightCol: {
            type: [Number, String],
            default: null
        },
        borderBottom: {
            type: Boolean,
            default: false
        },
        noPadding: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        classList() {
            let classList = ['app-row'];

            if (this.noPadding) {
                classList.push('pa-0');
            }

            if (this.borderBottom) {
                classList.push('app-row--border-bottom');
            }

            return classList.join(' ');
        }
    }
};
</script>

<style lang="scss">
.app-row {
    padding: 0 2.5rem;

    &--border-bottom {
        .app-row__row {
            border-bottom: 1px solid var(--v-primaryLight-base);
        }
    }
}
</style>
